import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { nucleusApiExtension } from './api';
import { entityNucleusContent } from './extensions/entityContent';
import { entityNucleusOverviewCard } from './extensions/entityCard';

export const nucleusModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [nucleusApiExtension, entityNucleusContent, entityNucleusOverviewCard],
});

export default nucleusModule;
